const routes = [
    {
        path: '', name: 'home',
        component: () => import('@/views/Accueil.vue')
    },
    {
        path: "/demande-diff",
        name: "DemandeDiff",
        component: () => import("@/views/DemandeDiff"),
        props: true
    },
    {
        path: "/demande-diff-societe",
        name: "DemandeDiffSociete",
        component: () => import("@/views/DemandeDiffSociete"),
        props: true
    },
    {
        path: "/correctionInformation",
        name: "CorrectionDemande",
        component: () => import("@/views/CorrectionDemande"),
        props: true
    },
    {
        path: "/correctionInformationSociete",
        name: "CorrectionDemandeSociete",
        component: () => import("@/views/CorrectionDemandeSociete"),
        props: true
    },
    {
        path: "/page-erreur",
        name: "pageErreur",
        component: () => import("@/views/pageErreur"),
        props: true
    },
    {
        path: "/detail-actualite/:id",
        name: "detail-actualite",
        component: () => import("@/views/detailActualite"),
        props: true
    },
    {
        path: "/detail-formation/:id",
        name: "detail-formation",
        component: () => import("@/views/detailFormation"),
        props: true
    },
    {
        path: "/participer",
        name: "participer",
        component: () => import("@/views/Participer.vue"),
        props: true
    },
    {
        path: "/recharger-document",
        name: "recharger-document",
        component: () => import("@/views/RechargerDocument.vue"),
        props: true
    },
    {
        path: "/mot-du-president",
        name: "mot-du-president",
        component: () => import("@/views/portail/motPresident.vue"),
        props: true
    },
    {
        path: "/modele-docmument",
        name: "modele-docmument",
        component: () => import("@/views/portail/modelDocument.vue"),
        props: true
    },
    {
        path: "/texte-fondamentaux",
        name: "texte-fondamentaux",
        component: () => import("@/views/portail/texteFondamentaux.vue"),
        props: true
    },
    {
        path: "/presentation",
        name: "presentation",
        component: () => import("@/views/portail/presentation.vue"),
        props: true
    },
    {
        path: "/participants/verification/attestation",
        name: "verification",
        component: () => import("@/views/portail/verification.vue"),
        props: true
    },
    {
        path: "/participants/verification/certificat",
        name: "verification-certificat",
        component: () => import("@/views/portail/verificationCertificat.vue"),
        props: true
    },
    {
        path: "/missions-attributions",
        name: "missions",
        component: () => import("@/views/portail/mission.vue"),
        props: true
    },
    {
        path: "/assemble-general",
        name: "assemble-general",
        component: () => import("@/views/portail/assemble.vue"),
        props: true
    },
    {
        path: "/conseil-ordre",
        name: "conseil-ordre",
        component: () => import("@/views/portail/conseil.vue"),
        props: true
    },
    {
        path: "/comites",
        name: "comites",
        component: () => import("@/views/portail/comite.vue"),
        props: true
    },
    {
        path: "/commissaire-gouvernement",
        name: "commissaire-gouvernement",
        component: () => import("@/views/portail/commissaire.vue"),
        props: true
    },
    {
        path: "/condition-inscription",
        name: "condition-inscription",
        component: () => import("@/views/portail/conditionInscription.vue"),
        props: true
    },
    {
        path: "/procedure",
        name: "procedure",
        component: () => import("@/views/portail/procedure.vue"),
        props: true
    },
    {
        path: "/formation-list",
        name: "formation-list",
        component: () => import("@/views/portail/formationList.vue"),
        props: true
    },
    {
        path: "/actualite-list",
        name: "actualite-list",
        component: () => import("@/views/portail/actualiteList.vue"),
        props: true
    },
    {
        path: "/contact",
        name: "contact",
        component: () => import("@/views/portail/nousContacter.vue"),
        props: true
    },
    {
        path: "/personnes-physiques",
        name: "personnes-physiques",
        component: () => import("@/views/portail/ListExpertComptable.vue"),
        props: true
    },
    {
        path: "/personnes-morales",
        name: "cga",
        component: () => import("@/views/portail/ListCGA.vue"),
        props: true
    },
    {
        path: "/comptables-agrees",
        name: "comptables-agrees",
        component: () => import("@/views/portail/listComptableAgree.vue"),
        props: true
    },
    {
        path: "/experts-stagiaires",
        name: "expert-stagiaire",
        component: () => import("@/views/portail/Stagiaire.vue"),
        props: true
    },
    {
        path: "/experts-comptables-entite",
        name: "expert-comptable-entite",
        component: () => import("@/views/portail/ListExpertComptableEntite.vue"),
        props: true
    },
    {
        path: "/condition-generale-utilisation",
        name: "condition-generale-utilisation",
        component: () => import("@/views/portail/cgu.vue"),
        props: true
    },
    {
        path: "/mentions-legales",
        name: "mentions-legales",
        component: () => import("@/views/portail/mentionsLegales.vue"),
        props: true
    },
    {
        path: "/annuaire-service",
        name: "annuaire-service",
        component: () => import("@/views/portail/annuaireService.vue"),
        props: true
    },
    {
        path: "/rapport-activite",
        name: "rapport-activite",
        component: () => import("@/views/portail/rapportActivite.vue"),
        props: true
    },
    {
        path: "/faq-inscription",
        name: "faq-inscription",
        component: () => import("@/views/portail/faqInscription.vue"),
        props: true
    },
    {
        path: "/rechercher-professionnel",
        name: "rechercheProfessionnel",
        component: () => import("@/views/portail/rechercheProfessionnel.vue"),
        props: true
    },
    {
        path: "/orientation-strategique",
        name: "orientationStrategique",
        component: () => import("@/views/portail/orientationStrategique.vue"),
        props: true
    },
    {
        path: "/profession/expert-comptable",
        name: "expert-comptable",
        component: () => import("@/views/portail/profession/Expert-Comptable.vue"),
        props: true
    },
    {
        path: "/profession/commissaire-comptes",
        name: "commissaire-comptes",
        component: () => import("@/views/portail/profession/Commissaire-comptes.vue"),
        props: true
    },
    {
        path: "/profession/expert-comptable-stagiaire",
        name: "expert-comptable-stagiaire",
        component: () => import("@/views/portail/profession/Expert-Stagiaires.vue"),
        props: true
    },
    {
        path: "/profession/societe-expert-comptable",
        name: "societe-expert-comptable",
        component: () => import("@/views/portail/profession/Societe-Expertise-Comptable.vue"),
        props: true
    },
    {
        path: "/profession/centre-gestion-agree",
        name: "centre-gestion-agree",
        component: () => import("@/views/portail/profession/Centre-Gestion-Agree.vue"),
        props: true
    },
    {
        path: "/profession/comptable-agree",
        name: "comptable-agree",
        component: () => import("@/views/portail/profession/Comptable-Agree.vue"),
        props: true
    },
    {
        path: "/profession/expert-comptable-entite",
        name: "expert-comptable-entite",
        component: () => import("@/views/portail/profession/Expert-Comptable-Entite.vue"),
        props: true
    },
    {
        path: "/profession/organisation-affiliee",
        name: "organisation-affiliee",
        component: () => import("@/views/portail/profession/Organisation-Affiliee.vue"),
        props: true
    },
    {
        path: "/nous-rejoindre",
        name: "nous-rejoindre",
        component: () => import("@/views/portail/nousRejoindre.vue"),
        props: true
    },
    {
        path: "/equipe-dirigeante",
        name: "equipe-dirigeante",
        component: () => import("@/views/portail/equipeDirigeante.vue"),
        props: true
    },
    {
        path: "/organigramme",
        name: "organigramme",
        component: () => import("@/views/portail/organigramme.vue"),
        props: true
    },
    {
        path: "/politique-confidentialite",
        name: "politique-confidentialite",
        component: () => import("@/views/portail/politiqueConfidentialite.vue"),
        props: true
    },
    {
        path: '/mediatheque',
        name: 'mediatheque',
        component: () => import('@/views/portail/mediatheque.vue'),
        props: true
    },
    {
        path: '/questionnaire/:lienUnique',
        name: 'questionnaire-public',
        component: () => import('@/views/portail/questionnairePublic.vue'),
        props: (route) => {
            // Gérer le cas où lienUnique pourrait contenir &participantId=
            let lienUnique = route.params.lienUnique;
            if (lienUnique && lienUnique.includes('&participantId=')) {
                const parts = lienUnique.split('&participantId=');
                return {
                    lienUnique: parts[0],
                    participantId: parts[1] ? parseInt(parts[1]) : null
                };
            }
            return {
                lienUnique: lienUnique,
                participantId: route.query.participantId ? parseInt(route.query.participantId) : null
            };
        }
    },
];

export default [
    {
        path: '/',
        component: () => import('@/views/espace/Home'),
        children: [...routes]
    },
    {
        path: '/inscription',
        name: 'signup',
        component: () => import('@/views/Signup'),
        beforeEnter: (to, from, next) => {
            const emailValid = localStorage.getItem("emailValid");

            if (!emailValid) {
                next({ name: "emailValidation" });
            } else {
                next(); 
            }
        },
    },
    {
        path: '/email-validation',
        name: 'emailValidation',
        component: () => import('@/views/Validation.vue')
    },
    {
        path: '/suivre-demande',
        name: 'suivre-demande',
        component: () => import('@/views/suiviDemande.vue')
    },

]